import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'containerMsf'
})
export class ContainerMsfPipe implements PipeTransform {

    transform(value: string,altitude:number,deadZone:number): any {
        if (!value) {
            return '';
        }
        var calc =(((altitude-deadZone)-(parseInt(value) - deadZone)) * 100) / (altitude-deadZone);
        if(calc<0){
            calc=0;
        } 
        else if(calc>100){
            calc=100;
        }
        return calc;
    }
}
